module.exports = __webpack_public_path__ + "static/img/li4_2.dbe371ce.png";